import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartContext = createContext(null);
const KEY = "vdz_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [...prev, {
        product_id: product.id,
        slug: product.slug,
        title: product.title,
        price: product.price,
        cover_image: product.cover_image,
        quantity: qty,
      }];
    });
    setDrawerOpen(true);
  };

  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const setQty = (product_id, quantity) => setItems((prev) =>
    prev.map((i) => (i.product_id === product_id ? { ...i, quantity: Math.max(1, quantity) } : i))
  );
  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const shipping = useMemo(() => (subtotal === 0 ? 0 : subtotal >= 150 ? 0 : 20), [subtotal]);
  const total = subtotal + shipping;
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  const value = { items, add, remove, setQty, clear, subtotal, shipping, total, count, drawerOpen, setDrawerOpen };
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
};
